// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"176496e9","359":"9908bea8","477":"dbb91507","532":"04f0375b","620":"13c208df","659":"64deb659","726":"4228e2bc","752":"b08f0b1c","944":"fd325494","985":"b4b3cf29"}[chunkId] + ".chunk.js";
};